"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * Generate what text goes inside the prompt based on the props to the prompt
 */
function promptText(props) {
    if (props.running) {
        return "[*]";
    }
    if (props.queued) {
        return "[…]";
    }
    if (typeof props.counter === "number") {
        return `[${props.counter}]`;
    }
    return "[ ]";
}
exports.promptText = promptText;
const BarePrompt = (props) => {
    if (props.blank) {
        return null;
    }
    return React.createElement("div", { className: props.className }, promptText(props));
};
exports.Prompt = styled_components_1.default(BarePrompt) `
  font-family: monospace;
  font-size: 12px;
  line-height: 22px;
  /* For creating a buffer area for <Prompt blank /> */
  min-height: 22px;

  color: black;

  width: var(--prompt-width, 50px);
  padding: 9px 0;

  text-align: center;

  color: var(--theme-cell-prompt-fg, black);
  background-color: var(--theme-cell-prompt-bg, #fafafa);
`;
exports.Prompt.defaultProps = {
    counter: null,
    running: false,
    queued: false,
    blank: false
};
exports.Prompt.displayName = "Prompt";
exports.PromptBuffer = styled_components_1.default(exports.Prompt) ``;
exports.PromptBuffer.defaultProps = {
    blank: true
};
